import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-surface',
  templateUrl: './surface.component.html',
  styleUrls: ['./surface.component.scss'],
  standalone: false
})
export class SurfaceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
